import { ThemeProvider } from './theme/theme-provider';
import { AuthProvider } from './context/AuthContext';
import { ProjectProvider } from './context/ProjectContext';
import { SidebarProvider } from './context/SidebarContext';
import { Layout } from './components/Layout/shared';
import { AppRoutes } from './routes/AppRoutes';

export default function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <AuthProvider>
        <ProjectProvider>
          <SidebarProvider>
            <Layout>
              <AppRoutes />
            </Layout>
          </SidebarProvider>
        </ProjectProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}